module.exports = __webpack_public_path__ + "img/law-badge.5e5d81a7.png";